import React, { useId, useState } from "react";
import Swal from "sweetalert2";

export default function MultipleFilesAttachments({
  attachments,
  setAttachments,
}) {
  const id = useId();
  const changeFileName = (e, index) => {
    const newAttachments = [...attachments];
    newAttachments[index].name = e.target.value;
    setAttachments(newAttachments);
  };

  const deleteAttachment = (index) => {
    const newAttachments = [...attachments];
    newAttachments.splice(index, 1);
    setAttachments(newAttachments);
  };

  const onSelectFile = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      return;
    }
    const MAX_SIZE_MB = 50;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

    // I've kept this example simple by using the first image instead of multiple
    // setSelectedFile(e.target.files[0]);
    const file = e.target.files[0];
    let type = "other";
    if (file.size > MAX_SIZE_BYTES) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "File size exceeds 50MB!",
        confirmButtonText: "OK",
      });
      return;
    }

    if (file.type.startsWith("image/")) {
      type = "image";
    } else if (file.type === "application/pdf") {
      type = "pdf";
    } else if (file.type.startsWith("video/")) {
      type = "video";
    }
    const objectUrl = URL.createObjectURL(file);
    const newAttachment = {
      name: file.name,
      file,
      type,
      value: objectUrl,
    };
    setAttachments((prev) => [...prev, newAttachment]);
  };

  return (
    <div className="row justify-content-lg-start form-darker">
      {attachments.map((attachment, index) => (
        <div key={index} className={"col-md-4 position-relative"}>
          <div
            className="position-absolute"
            style={{
              top: "0",
              right: "10px",
              zIndex: "1",
              cursor: "pointer",
              color: "red",
              padding: "5px",
            }}
            onClick={() => deleteAttachment(index)}
          >
            <i className="fa fa-trash"></i>
          </div>
          {attachment.type === "image" && (
            <img
              src={attachment.exist ? attachment.url : attachment.value}
              className={"img-fluid w-100"}
              alt=""
            />
          )}
          {attachment.type === "video" && (
            <video
              src={attachment.exist ? attachment.url : attachment.value}
              className={"img-fluid w-100"}
              width={"100%"}
              controls
            />
          )}
          {attachment.type === "pdf" && (
            <iframe
              src={attachment.exist ? attachment.url : attachment.value}
              className={" w-100"}
              width={"100%"}
              height={"350px"}
            />
          )}
          {attachment.type === "other" && (
            <div
              style={{ height: "200px", paddingTop: "95px" }}
              className={"border-theme border-1 border w-100 text-center"}
            >
              No Preview for this File
            </div>
          )}

          <div className="my-2">
            <input
              type="text"
              className={"form-control"}
              value={attachment.name}
              onChange={(e) => changeFileName(e, index)}
            />
          </div>
        </div>
      ))}
      <div className="col-md-4 position-relative">
        <label
          htmlFor={id}
          className={"border-theme border-1 border w-100"}
          style={{ height: "150px", cursor: "pointer" }}
        >
          <div
            style={{
              cursor: "pointer",
              position: "absolute",
              top: "0",
              left: "50%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              minHeight: "150px",
              alignItems: "center",
              transform: "translateX(-50%)",
            }}
          >
            <i className="fa fa-file-archive" style={{ fontSize: "25px" }}></i>

            <div style={{ textAlign: "center" }}>
              {attachments.length < 5
                ? "Add attachments"
                : "Add More attachments"}
            </div>
          </div>
        </label>
        <input
          onChange={onSelectFile}
          style={{ visibility: "hidden", position: "absolute" }}
          type="file"
          id={id}
        />
      </div>
    </div>
  );
}
